
/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  UpdatePhoneNumberRequest,
} from '../models';
import {
    UpdatePhoneNumberRequestFromJSON,
    UpdatePhoneNumberRequestToJSON,
} from '../models';

export interface UpdateAccountPhoneNumberRequest {
    accountId: string;
    updatePhoneNumberRequest: UpdatePhoneNumberRequest;
}

/**
 * 
 */
export class ClientAccountApi extends runtime.BaseAPI {

    /**
     * Update the phone number of a client account
          */
    async updateAccountPhoneNumberRaw(requestParameters: UpdateAccountPhoneNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling updateAccountPhoneNumber().'
            );
        }

        if (requestParameters['updatePhoneNumberRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePhoneNumberRequest',
                'Required parameter "updatePhoneNumberRequest" was null or undefined when calling updateAccountPhoneNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/account/{accountId}/phone-number`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePhoneNumberRequestToJSON(requestParameters['updatePhoneNumberRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update the phone number of a client account
          */
    async updateAccountPhoneNumber(requestParameters: UpdateAccountPhoneNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAccountPhoneNumberRaw(requestParameters, initOverrides);
    }

}
